// library functions

import { TimelineLite } from "gsap/TimelineLite";

// static data
import * as Constants from "Data/Constants";
import * as VO from "Data/VO";

// pubsub topics
import * as Topics from "Data/Topics";
import { REGISTER_FOCUSABLES } from "html-living-framework/lib/Data/Topics";

// gameobjects
import { Button } from "GameObjects/Button";
import { ExteriorLeftRightButtons } from "GameObjects/GameExterior/ExteriorLeftRightButtons";
import { ExteriorLuna } from "GameObjects/GameExterior/ExteriorLuna";
import { HomeButton } from "GameObjects/GameExterior/HomeButton";
import { ProgressTracker } from "GameObjects/GameExterior/ProgressTracker";
import TimedButton from "GameObjects/GameExterior/TimedButton";
import { HUD } from "GameObjects/HUD";

// types and interfaces
import type { HidingSpotID } from "Data/GameConfig";
import type { ILevelState } from "Interfaces/ILevelState";

// mr singleton
import {GameState} from "Models/GameState";

export class ExteriorHUD extends HUD {
    public readonly luna: ExteriorLuna;
    public readonly progressTracker: ProgressTracker;
    public readonly arrowButtons: ExteriorLeftRightButtons;
    // protected readonly hitAreaButton: Button;
    public readonly homeButton: Button;
    public readonly hintButton: Button;
    protected hintTimeline?: TimelineLite;
    protected readonly cheatButton: Button;

    constructor() {
        super();

        this.progressTracker = new ProgressTracker();
        this.progressTracker.position.set(185, 0);
        this.BottomLeft.addChild(this.progressTracker);

        this.luna = new ExteriorLuna();
        this.luna.position.set(
            this.luna.bg.width / 2 + 24.5,
            -this.luna.bg.height / 2 + 64,
        );
        this.BottomLeft.addChild(this.luna);

        this.cheatButton = new Button(
            this.HandleCheatButtonClicked.bind(this),
            "button-paint-fill",
            Constants.SPRITESHEET_UI,
        );
        this.cheatButton.scale.set(0.5);
        this.cheatButton.position.set(-this.cheatButton.width / 2, this.cheatButton.height / 2);
        this.cheatButton.addText("(CHEAT)\nfind all", Constants.FONT_GEL_MED_22, 16);
        // this.TopRight.addChild(this.cheatButton); // Uncomment this to show the cheat button

        this.homeButton = new HomeButton();
        this.homeButton.position.set(this.homeButton.width / 2 + 8, this.homeButton.height / 2 + 8);
        this.TopLeft.addChild(this.homeButton);

        this.hintButton = new TimedButton(
            this.HandleHintButtonClicked.bind(this),
            "hint-button",
            Constants.SPRITESHEET_UI,
            1.5 * 1000,
            30 * 1000,
            VO.UI.EXTERIOR.UI13,
            "ui_click",
        );
        this.hintButton.position.set(
            this.hintButton.width / 2 + 8,
            this.hintButton.height / 2 + 8 + this.homeButton.height + 8,
        );
        this.TopLeft.addChild(this.hintButton);
/*
        this.hitAreaButton = new Button(
            this.HandleHitAreaButtonClicked.bind(this),
            "button-paint-fill",
            Constants.SPRITESHEET_UI,
        );
        this.hitAreaButton.scale.set(0.5);
        this.hitAreaButton.position.set(-this.hitAreaButton.width / 2, this.hitAreaButton.height / 2);
        this.hitAreaButton.addText("(CHEAT)\ntoggle hitareas", Constants.FONT_GEL_MED_22, 16);
        this.TopRight.addChild(this.hitAreaButton);
 */
        this.arrowButtons = new ExteriorLeftRightButtons();
        this.addChild(this.arrowButtons);
    }

    public init(pSize: PIXI.Point, pData: ILevelState) {
        super.init(pSize, pData);
        this.luna.init(pSize, pData);
        this.progressTracker.init(pData);
        this.arrowButtons.init(pSize, pData);
        PubSub.publishSync(REGISTER_FOCUSABLES, [
            this.arrowButtons.leftButton,
            this.arrowButtons.rightButton,
            this.hintButton,
            // this.cheatButton,
            this.homeButton,
            // this.hitAreaButton,
        ]);
        return this;
    }

    public animateIn() {
        super.animateIn();
        this.luna.animateIn();
        this.arrowButtons.animateIn();
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        this.luna.onResize(pSize);
        this.arrowButtons.onResize(pSize);
    }

    public destroy(pOptions?: PIXI.DestroyOptions | boolean) {
        this.hintTimeline?.kill();
        super.destroy(pOptions);
    }

    public PulseHintButton() {
        if (this.hintTimeline === undefined) {
            this.hintTimeline = new TimelineLite();
        }
        this.hintTimeline?.kill();
        this.hintTimeline
            .to(this.hintButton, 0.5, {pixi: {scale: 1.2}})
            .to(this.hintButton, 0.5, {pixi: {scale: 1}})
            .to(this.hintButton, 0.5, {pixi: {scale: 1.2}})
            .to(this.hintButton, 0.5, {pixi: {scale: 1}})
            .to(this.hintButton, 0.5, {pixi: {scale: 1.2}})
            .to(this.hintButton, 0.5, {pixi: {scale: 1}})
            .to(this.hintButton, 0.5, {pixi: {scale: 1.2}})
            .to(this.hintButton, 0.5, {pixi: {scale: 1}})
            .to(this.hintButton, 0.5, {pixi: {scale: 1.2}})
            .to(this.hintButton, 0.5, {pixi: {scale: 1}})
            .to(this.hintButton, 0.5, {pixi: {scale: 1.2}})
            .to(this.hintButton, 0.5, {pixi: {scale: 1}})
        ;
    }

    protected HandleGoInsideButtonClicked() {
       GameState.Instance.GoToInterior();
    }

    protected HandleHintButtonClicked() {
        // console.log("hint");
        PubSub.publishSync(Topics.HINT_BUTTON_PRESSED, this.hintButton);
    }

    protected HandleCheatButtonClicked() {
        for (const item of GameState.Instance.currentLevelConfig.hiddenitems) {
            if (typeof(item.hidingspot) === "string") {
                GameState.Instance.SearchHidingSpot(item.hidingspot as HidingSpotID);
            }
            else {
                GameState.Instance.SearchHidingSpot(item.hidingspot.id as HidingSpotID);
            }
        }
    }

/*
    protected HandleHitAreaButtonClicked() {
        PubSub.publishSync(Topics.TOGGLE_HIT_AREA_RENDERER, undefined);
    }
*/
}
